<template>
  <b-modal id="changeShipmentAccount" :title="'Change Shipment Account'" :ref="_uid" @ok="handleOk" :no-close-on-backdrop="true">
    <b-container>
      <form ref="form">
        <b-form-group :label="$t('history.modal.body.Company')">
          <vSelect
              :dynamicWidth="false"
              label="name"
              :clearable="false"
              :options="getCompanies"
              v-model="companyId"
              :reduce="(company) => company.id"
              :placeholder="$t('createShipment.placeholder.Choose Company')"
              name="companyDropdown"
          />
        </b-form-group>

        <div v-if="accounts.length > 0">
          <b-form-group :label="$t('history.modal.body.Account')">
            <vSelect
                :dynamicWidth="false"
                :clearable="false"
                :options="accounts"
                :reduce="(account) => account.id"
                v-model="accountId"
                label="displayName"
                :placeholder="$t('createShipment.placeholder.Select Account')"
            />
          </b-form-group>
        </div>
        <b-form-invalid-feedback
            v-if="invalidFeedback"
            :state="!state"
        >{{ invalidFeedback }}</b-form-invalid-feedback>
      </form>
    </b-container>
  </b-modal>
</template>

<script>
import vSelect from "@/components/vSelect";
import { mapGetters } from 'vuex';
import {ACTIONS, CORE_PREFIX, HISTORY_PREFIX} from "@/store/constants";
export default {
  components:{
    vSelect
  },
  name: "ChangeShipmentAccountModule",
  data(){
    return {
      shipmentIds:[],
      companyId: 0,
      accountId: 0,
      accounts: [],
      invalidFeedback: '',
    }
  },
  watch:{
    companyId(){
      this.fetchAccount();
    }
  },
  methods:{
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.changeAccount();
    },
    changeAccount(){
      if(this.accountId !== 0){
        this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.CHANGE_SHIPMENTS_ACCOUNT, {shipmentIds: this.shipmentIds, companyId: this.companyId, accountId: this.accountId});
        this.$nextTick(() => {
          this.$bvModal.hide("changeShipmentAccount");
        });
      } else if(this.accountId === 0) {
        this.invalidFeedback = 'Please select an Account from the list';
      }
    },
    show(shipmentIds){
      this.shipmentIds = shipmentIds;
      this.$refs[this._uid].show();
    },
    async fetchAccount(){
      this.accounts = [];

      const response = await this.$store.dispatch(
          HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_COMPANY_ACCOUNTS,
          this.companyId
      );

      this.accounts = response.data;
    }
  },
  computed: {
    ...mapGetters('core', ['getCompanies']),
    state() {
      return this.accountId === 0;
    },
  }
}
</script>

<style scoped>

</style>